module.exports = __webpack_public_path__ + "img/decor-rec.29db08cd.png";